import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
function formatDate(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}
export default function NewsCardGrid(t0) {
  const $ = _c(6);
  const {
    items: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  let t3;
  if ($[2] !== items) {
    t3 = items.map(_temp);
    $[2] = items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
function _temp(item) {
  const imageUrl = item?.media?.previewsrc || "";
  const hasImage = Boolean(imageUrl);
  const href = item?.url || (item?.slug ? `/news/${item.slug}` : "#");
  return <Link key={`${item.id}-${item.slug}`} href={href} className="bg-white rounded-2xl shadow-[-2px_2px_20px_0_rgba(0,0,0,0.06)] flex flex-col hover:shadow-[-1px_6px_30px_0_rgba(0,0,0,0.2)] transition-shadow duration-300 ease-out">{hasImage && <div className="w-full aspect-[398/221] overflow-hidden rounded-[14px] bg-[#E3E3E3]"><Image src={imageUrl} width={398} height={221} alt={item?.media?.altText || item?.title || "News image"} className="h-full w-full object-cover" /></div>}<div className={`2xl:px-7 px-6 2xl:pb-9 xl:pb-8 pb-6 flex-1 ${hasImage ? "pt-4" : "lg:pt-7 pt-5"}`}><p className="md:text-sm text-xs leading-[1.5em] text-[#626262] font-normal">{formatDate(item?.publishDate)}</p><h2 className={`font-semibold text-[#323232] leading-[1.2em] lg:max-w-[90%] ${hasImage ? "line-clamp-3 lg:text-xl text-lg mt-1 md:mt-0" : "line-clamp-6 mt-6 font-outfit lg:text-[28px] text-2xl"}`}>{item?.title}</h2></div>{!hasImage && <div className="flex-1" />}</Link>;
}